/**
 * mutates the applicant.history.data property with the data given, as-is
 */
export const getHistoryInitialData = (state, { data = [], status }) => {
  state.applicant.history.status = status;
  state.applicant.history.data = data;
};
